export default "__VITE_ASSET__DNkSf42h__"